import { jsx as _jsx } from "preact/jsx-runtime";
import { loadStripe } from '@stripe/stripe-js';
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'preact/hooks';
import { CardElementStyle } from '../../const/stripe/CardElementStyle';
const StripeCardInputForm = ({ storeIdentifier, onChange }) => {
    const [stripe, setStripe] = useState(null);
    const [stripeElements, setStripeElements] = useState(null);
    useLayoutEffect(() => {
        (async () => {
            if (!storeIdentifier) {
                return;
            }
            const stripeInstance = await loadStripe(storeIdentifier, { locale: 'ja' });
            setStripe(stripeInstance);
            if (stripeInstance) {
                setStripeElements(stripeInstance.elements({ locale: 'ja' }));
            }
        })();
    }, [storeIdentifier]);
    const wrapperRef = useRef(null);
    const stripeCardElement = useRef();
    const handleChange = useCallback((event) => {
        if (typeof onChange === 'function') {
            onChange(stripe, event, stripeCardElement.current);
        }
    }, [stripe, stripeCardElement]);
    useEffect(() => {
        if (!stripeElements || !wrapperRef.current) {
            return;
        }
        const cardElement = stripeElements.create('card', { hidePostalCode: true, style: CardElementStyle, iconStyle: 'solid', disableLink: true });
        cardElement.mount(wrapperRef.current);
        cardElement.on('change', handleChange);
        stripeCardElement.current = cardElement;
    }, [stripeElements, wrapperRef]);
    if (stripe === null) {
        return null;
    }
    return (_jsx("article", { children: _jsx("div", Object.assign({ className: "only-card-input-form" }, { children: _jsx("div", { ref: wrapperRef }, void 0) }), void 0) }, void 0));
};
export default StripeCardInputForm;
